import { render, staticRenderFns } from "./SubscriptionsItem.vue?vue&type=template&id=11aa54d6&"
import script from "./SubscriptionsItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubscriptionsItem.vue"
export default component.exports